import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.array.find";
import "core-js/modules/es7.promise.finally";
import "core-js/modules/es6.regexp.search";
import "core-js/modules/es6.object.assign";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import ApiService from '../../services/apiService';
import { mapState } from 'vuex';
import debounce from 'lodash/debounce';
export default {
  name: 'CoreUserfinder',
  props: {
    hideIcon: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    label: {
      type: String,
      default: function _default() {
        return '';
      }
    },
    userId: {
      type: String,
      default: function _default() {
        return '';
      }
    }
  },
  data: function data() {
    var _this = this;

    return {
      titleLimit: 60,
      entries: [],
      isLoading: false,
      rules: [function (v) {
        return !!v || _this.$i18n_t('Common.userIsRequired');
      }],
      lclObject: null,
      search: null,
      lastSearch: null
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color'])), {}, {
    userSearchResult: function userSearchResult() {
      var _this2 = this;

      return this.entries.map(function (entry) {
        var name = "".concat(entry.firstName, " ").concat(entry.lastName, " (").concat(entry.email, ")");
        var title = name.length > _this2.titleLimit ? "".concat(name.slice(0, _this2.titleLimit), "...") : name;
        return Object.assign({}, entry, {
          title: title,
          id: entry.id
        });
      });
    }
  }),
  watch: {
    search: debounce(function () {
      // Items have already been requested
      if (this.isLoading) {
        return;
      }

      this.isLoading = true;
      this.fetch();
    }, 100),
    userId: function userId() {
      this.findUserObject();
    }
  },
  mounted: function mounted() {
    this.fetch();
  },
  methods: {
    process: function process() {
      this.$emit('userSelected', this.lclObject);
    },
    fetch: function fetch() {
      var _this3 = this;

      this.isLoading = true;
      var currentSearch = this.search || this.lastSearch;

      if (this.lastSearch === currentSearch || (this.lclObject || {}).title === currentSearch) {
        this.isLoading = false;
        return;
      }

      this.lastSearch = currentSearch;
      ApiService.fetchUsers([], ['ancestors'], [], 0, 100, undefined, currentSearch).then(function (data) {
        _this3.count = data.users.length;
        _this3.entries = data.users;
      }).catch(function (error) {
        console.error('Error finding Users', error);
      }).finally(function () {
        return _this3.isLoading = false;
      });
    },
    findUserObject: function findUserObject() {
      var _this4 = this;

      var lookedUp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      this.lclObject = this.userSearchResult.find(function (item) {
        return item.id === _this4.userId;
      });

      if (!this.lclObject && this.userId && !lookedUp) {
        this.isLoading = true;
        ApiService.fetchUsers([], ['ancestors'], [], 0, 100, undefined, this.userId).then(function (data) {
          _this4.count = data.users.length;
          _this4.entries = data.users;

          _this4.findUserObject(true);
        }).catch(function (error) {
          console.error('Error finding Users', error);
        }).finally(function () {
          return _this4.isLoading = false;
        });
      }
    }
  }
};